import {
  useInvestmentPerformance,
  useInvestmentsId,
  useTradingGainForInvestment,
} from "@rentablo/api/apiv1";
import { useCurrencyDisplay } from "@providers/CurrencyDisplayProvider";
import { GainLossStatistics } from "./GainLossStatistics";

interface Props {
  investmentId: number;
}

export const GainLossStatisticsLoader = ({ investmentId }: Props) => {
  const { selectedCurrencyView, getDisplayCurrency } = useCurrencyDisplay();
  const isOriginal = selectedCurrencyView === "original";

  const { data: investment, isFetching: isInvestmentLoading } =
    useInvestmentsId(
      { id: investmentId },
      { enabled: investmentId !== undefined }
    );

  const currency = getDisplayCurrency(investment?.currency);

  const {
    data: realizedGainByBooking,
    isFetching: isRealizedGainByBookingLoading,
  } = useTradingGainForInvestment(
    { id: investmentId, displayCurrency: currency },
    { enabled: investmentId !== undefined }
  );

  const {
    data: investmentPerformance,
    isFetching: isInvestmentPerformanceLoading,
  } = useInvestmentPerformance(
    { id: investmentId, displayCurrency: currency },
    { enabled: investmentId !== undefined }
  );

  const isFetching =
    isInvestmentLoading ||
    isInvestmentPerformanceLoading ||
    isRealizedGainByBookingLoading;

  return (
    <GainLossStatistics
      isFetching={isFetching}
      investment={investment}
      realizedGainByBooking={realizedGainByBooking}
      investmentPerformance={investmentPerformance}
      currency={currency}
      isOriginal={isOriginal}
    />
  );
};
